export default __webpack_public_path__ + "static/newFeature-MenuItem-729697ca84920632c0175f62095f5ff8.gif";